import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TemplateText } from 'src/app/services/application-resources/models/template-resource-data';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-template-text-list',
    templateUrl: './template-text-list.component.html',
    styleUrls: ['./template-text-list.component.scss'],
    standalone: false
})
export class TemplateTextListComponent implements OnInit {
  @Input() templateTexts: TemplateText[];
  @Output() onTemplateClick = new EventEmitter<string>();
  constructor(private translatePipe: TranslatePipe) {}

  ngOnInit(): void {}

  templateClick(templateText: TemplateText) {
    const translatedText = this.translatePipe.transform(templateText.text);
    this.onTemplateClick.emit(translatedText);
  }
}
